
import axios from "axios"; 
import { Api } from "@/api";

const FolderRepository = { 

    /**
     * getFolders
     * 
     * 
     * @returns {Object} server response
     */    
     async getFolders() {
        try {
            const response = await axios.create({withCredentials: true}).get(Api.BACKEND_URL + Api.FOLDERLIST_ACTION);
            //console.log('[FolderRepository] getFolders response', response);
            if (response.data.success) {
                return response;
            } else {
                return response;
            }            
        } catch (error) {
            //statement.resetStateValues();
            //console.error(error);
            //ErrorHandler.createSystemError(error.message);
            return {};
        }
    },        
}

export default FolderRepository;